var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPositionCarPark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 20,
    rx: 2.5,
    fill: "white",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 20,
    rx: 2.5,
    stroke: "#FF0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.71857 6.27273L10.9686 9.90341H11.0368L13.2868 6.27273H14.5311L11.7868 10.6364L14.5311 15H13.2868L11.0368 11.4375H10.9686L8.71857 15H7.47425L10.2868 10.6364L7.47425 6.27273H8.71857Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositionCarPark);
export default __webpack_public_path__ + "static/media/position_car_park.45f7d9787801900e29da48f9237662dd.svg";
export { ForwardRef as ReactComponent };